var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinesInternetBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 25.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#101820;stroke-linecap:square;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,31.333v-19.2A2.133,2.133,0,0,1,4.133,10H31.867A2.133,2.133,0,0,1,34,12.133v19.2a2.133,2.133,0,0,1-2.133,2.133H4.133A2.133,2.133,0,0,1,2,31.333Z",
    transform: "translate(-2 -10)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 12.8,
    transform: "translate(5.333 18.134)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 4.267,
    transform: "translate(22.4 18.134)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.333,
    height: 4.267,
    transform: "translate(5.333 5.333)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.067,
    cy: 1.067,
    r: 1.067,
    transform: "translate(19.2 7.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.02,26.195a2.626,2.626,0,0,0,0-3.147",
    transform: "translate(-22.076 -16.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.861,26.433a5.835,5.835,0,0,0,0-6.933",
    transform: "translate(-24.335 -14.434)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinesInternetBanking);
export default __webpack_public_path__ + "static/media/Icon_Lines_InternetBanking.65e32ea6315e7ac5023f244b0f4f4cdd.svg";
export { ForwardRef as ReactComponent };